import { render, staticRenderFns } from "./codeQR.vue?vue&type=template&id=fa8c8eae&scoped=true"
import script from "./codeQR.vue?vue&type=script&lang=js"
export * from "./codeQR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8c8eae",
  null
  
)

export default component.exports